import React from 'react'

const CartColumns = () => {
    return (
        <div className='columns'>
            <h5>item</h5>
            <h5>price</h5>
            <h5>quantity</h5>
            <h5>subtotal</h5>
            <h5>Action</h5>
        </div>
    )
}

export default CartColumns